import { render, staticRenderFns } from "./ReportOvrig.vue?vue&type=template&id=6c842d46&scoped=true&"
import script from "./ReportOvrig.vue?vue&type=script&lang=js&"
export * from "./ReportOvrig.vue?vue&type=script&lang=js&"
import style0 from "./ReportOvrig.vue?vue&type=style&index=0&id=6c842d46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c842d46",
  null
  
)

export default component.exports